<ion-content color="lightmimbo">
  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)" color="primary">
    <ion-refresher-content pullingText="Pull to refresh" refreshingSpinner="circular" refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher>
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div class="ion-text-center ion-padding" *ngIf="!isLoading && articles.length===0">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-img src="../../../assets/images/MimboLogo.png" class="logo"></ion-img>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-text color="darkmimbo">No articles available at the moment. We promise you to add some. <br />
    </ion-text>
  </div>
  <ion-grid *ngIf="!isLoading && articles.length>0">
    <ion-row>
      <ion-col sizeXl="10" offsetXl="1">
        <ion-list color="lightmimbo">
          <div *ngFor="let article of articles">
            <ion-item detail [routerLink]="'/article/' + article.id" color="lightmimbo"
              style="padding-top: 4px; padding-bottom: 4px" class="list-item">
              <img [src]="article.image" class="avatar" />
              <div style="padding-bottom: 12px; padding-top: 12px">
                <h1>{{article.title}}</h1>
                <h6 [innerHTML]="article.content"></h6>
              </div>
            </ion-item>
          </div>
        </ion-list></ion-col></ion-row></ion-grid>
  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)" *ngIf="!isLoading && HasMoreData">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>